import { appStorage } from 'utils/storage';

export function resolveSizeClass(size?: number | string): string {
  if (typeof size === 'string' || Number.isNaN(size)) return '';

  const className = `box-size-${size}`;

  const createdClass = appStorage.memory.get<string>(className);

  if (createdClass) return createdClass;

  const style = document.createElement('style');

  style.innerHTML = `
    .${className} {
      height: ${size}px;
      width: ${size}px;
    }
  `;

  document.head.appendChild(style);

  appStorage.memory.set(className, className);

  return className;
}
